<div class="flex items-center justify-center bg-primary-500 h-screen">
  <div class="flex flex-col items-center px-8 py-8 border border-4 border-primary-700 rounded-3xl  bg-white">
    <img [height]="200" [width]="400" alt="Logo RAMASOFT" ngSrc="images/Logo-RAMASOFT-bleu.png">

    <div (keydown.enter)="resetPassword()"
         class="w-full max-w-sm border-2 border-primary-500 py-8 px-8 rounded-2xl flex flex-col gap-8">
      <elcia-text-input [control]="fg.controls.email" [label]="'user.email' | translate" [type]="'email'"/>

      <div>
        <elcia-text-input [control]="fg.controls.password" [label]="'user.password' | translate" [type]="'password'"/>
        @if (fg.controls.password.hasError('minLength8') && fg.controls.password.touched) {
          <p-message severity="error" size="small" variant="simple">{{ 'error.min-length-8' | translate }}</p-message>
        }
        @if (fg.controls.password.hasError('requireDigit') && fg.controls.password.touched) {
          <p-message severity="error" size="small" variant="simple">{{ 'error.require-digit' | translate }}</p-message>
        }
        @if (fg.controls.password.hasError('requireLowercase') && fg.controls.password.touched) {
          <p-message severity="error" size="small" variant="simple">{{ 'error.require-lowercase' | translate }}</p-message>
        }
        @if (fg.controls.password.hasError('requireUppercase') && fg.controls.password.touched) {
          <p-message severity="error" size="small" variant="simple">{{ 'error.require-uppercase' | translate }}</p-message>
        }
      </div>
      <div>
        <elcia-text-input [control]="fg.controls.confirmPassword" [label]="'user.confirm-password' | translate"
                          [type]="'password'"/>
        @if (fg.hasError('passwordMismatch') && fg.controls.confirmPassword.touched) {
          <p-message severity="error" size="small" variant="simple">{{ 'error.password-mismatch' | translate }}
          </p-message>
        }
      </div>

      <div class="flex justify-between gap-4">
        <div class="flex-1">
          <elcia-local-dropdown/>
        </div>
        <div>
          <elcia-button (onClick)="resetPassword()" [icon]="'save'" [label]="'action.save' | translate"/>
        </div>
      </div>
    </div>
  </div>
</div>

